import {
  SET_NOTIFICATIONS_SETTINGS,
  CLEAR_SETTINGS,
  SET_SETTINGS_MODAL,
} from './mutation-types'
import router from 'src/router'
import dataService from 'src/app.service'

const state = {
  notifications: {
    daily: 'all',
    immediate: 'all',
    oversight: [],
  },
  settingsModal: '',
}

const mutations = {
  [SET_NOTIFICATIONS_SETTINGS](state, data) {
    state.notifications = data
  },
  [CLEAR_SETTINGS](state) {
    state = {
      notifications: {},
    }
  },
  [SET_SETTINGS_MODAL](state, payload) {
    state.settingsModal = payload
  },
}

const actions = {
  setNotificationsSettings({ commit }, payload) {
    const authority = {
      origin: { organisation: 'asoko.projects.web' },
      initiator: { type: 'person' },
    }

    const requestBody = {
      authority,
      notifications: payload,
    }

    return dataService.put('/settings/projects', requestBody).then(res => {
      commit(SET_NOTIFICATIONS_SETTINGS, payload)
    })
  },
  getProjectsSettings({ commit }) {
    return dataService.get('/settings/projects').then(res => {
      const notifications = _.get(res.data, 'notifications')
      if (notifications) {
        commit(SET_NOTIFICATIONS_SETTINGS, notifications)
      }
    })
  },
  setSettingsModal({ commit }, payload) {
    commit(SET_SETTINGS_MODAL, payload)
    let path = router.currentRoute.path
    if (path[path.length - 1] !== '/') {
      path += '/'
    }
    const title = payload[0].toUpperCase() + payload.slice(1) + ' modal shown'
    this._vm.$ga.page({
      page: path + payload,
      title,
    })
    this._vm.$gtag.pageview({
      "page_title": title,
      "page_location": path + payload,
    })
  },
  hideSettingsModal({ commit }) {
    commit(SET_SETTINGS_MODAL, '')
  },
}

const getters = {
  notifications: state => state.notifications,
  settingsModal: state => state.settingsModal,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
